<app-expansion-panel [titre]="'Indice de résultats ' + idx()" [item]="form()" [isOpen]="true">
  <div class="px-lg pt-lg pb-xl gap-lg flex flex-col" [formGroup]="form()">
    <div hlmField>
      <label [for]="'indice' + idx()" hlmFieldLabel labelRequired>Nom de l'indice</label>
      <input [id]="'indice' + idx()" hlmInput formControlName="nom" />
      @if (nom.hasError('required') && nom.touched) {
        <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
      }
      @if (nom.hasError('notUnique')) {
        <hlm-field-error>Cet indice de résultats existe déjà</hlm-field-error>
      }
    </div>
  </div>
</app-expansion-panel>
